/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Part_3_TInputs */

const en_tut_part_3_t = /** @type {(inputs: Tut_Part_3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The virtual office`)
};

const id_tut_part_3_t = /** @type {(inputs: Tut_Part_3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kantor virtual`)
};

/**
* | output |
* | --- |
* | "The virtual office" |
*
* @param {Tut_Part_3_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_part_3_t = /** @type {((inputs?: Tut_Part_3_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Part_3_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_part_3_t(inputs)
	return en_tut_part_3_t(inputs)
});